import ReactGA from "react-ga4";

ReactGA.initialize('G-6NKMV3PMSB');

export const trackView = (viewName: string) => {
    ReactGA.send({ hitType: "pageview", page: viewName });
}
